// Groups that should NOT have access to the chatbot or recommendations features
export const CHATBOT_RESTRICTED_GROUPS = ['WBC-Externals'];
